import React, { useState } from 'react';
import Modal from '../Modal';

const Ubicacion = ({ onClick }) => {
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const open = () => {
    if (window.innerWidth > 769) {
      setIsMapModalOpen(true);
    } else {
      window.open('https://www.google.com/maps?ll=-23.660523,-70.402044&z=16&t=m&hl=es&gl=US&mapclient=embed&q=Gral.+Vel%C3%A1squez+890+1270038+Antofagasta', '_blank');
      if (onClick) onClick();
    }
  }

  return (
    <>
      <button
        onClick={open}
        className="btn-accion"
      >
        UBICACIÓN
      </button>

      <Modal
        isOpen={isMapModalOpen}
        onClose={() => setIsMapModalOpen(false)}
        title="Ubicación CAIMA"
      >
        <iframe
          title="Mapa de ubicación"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3644.4392833002387!2d-70.39549992374693!3d-23.65050047869791!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96afd5d4b2b7e45f%3A0x7f3d229fc506e709!2sGeneral%20Vel%C3%A1squez%20890%2C%20Antofagasta%2C%20Chile!5e0!3m2!1ses!2s!4v1701893155396!5m2!1ses!2s"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </Modal>
    </>
  );
};

export default Ubicacion; 